import { SplunkSearch, SplunkSavedSearch } from '@splunk/datasources';
import { EnterpriseTimeRangeInput } from '@splunk/dashboard-inputs';
import {
    mapWithRiskySearchToast,
    withRiskySearchToast,
} from '@splunk/dashboard-ui';
import type { PresetMap } from '@splunk/dashboard-types';
import CloudViewOnlyPreset from './CloudViewOnlyPreset';

export default {
    ...CloudViewOnlyPreset,
    inputs: {
        ...CloudViewOnlyPreset.inputs,
        'input.timerange': EnterpriseTimeRangeInput,
        'input.dropdown': withRiskySearchToast(
            CloudViewOnlyPreset.inputs['input.dropdown']
        ),
        'input.multiselect': withRiskySearchToast(
            CloudViewOnlyPreset.inputs['input.multiselect']
        ),
    },
    dataSources: {
        ...CloudViewOnlyPreset.dataSources,
        'ds.search': SplunkSearch,
        'ds.savedSearch': SplunkSavedSearch,
        'ds.chain': SplunkSearch,
    },
    visualizations: mapWithRiskySearchToast(CloudViewOnlyPreset.visualizations),
} as PresetMap;
